export class Serializer {
    static serialize(payload) {
        return typeof payload !== "string" ? JSON.stringify(payload) : payload;
    }
    static deserialize(payload) {
        let data;
        try {
            data = JSON.parse(payload);
        }
        catch (e) {
            data = payload;
        }
        return data;
    }
}
